import { render, staticRenderFns } from "./ed-calls-info-popup.component.vue?vue&type=template&id=06cb3163&scoped=true&"
import script from "./ed-calls-info-popup.component.ts?vue&type=script&lang=ts&"
export * from "./ed-calls-info-popup.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-calls-info-popup.view.scss?vue&type=style&index=0&id=06cb3163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb3163",
  null
  
)

export default component.exports